import { getQuestionRangeWithId } from "./excelInfo";
import { insertPageBreak, pasteQuestionValue } from "./export";
import { getJson, getQuestionObj, getQuestionRowsCount } from "./transform";

export const headerBlank = 4;
export const pageBreaks = ["ページの始まり", "ここから本調査"];

export async function moveQuestion(
  sheetName: string,
  questionId: string,
  nextQuestionId: string,
  excel: string[],
  newIndex: number = 0
) {
  // Excel上の該当範囲を取得
  const { rangeText } = await getQuestionRangeWithId(questionId, nextQuestionId, sheetName);

  const questionObj = await Excel.run(async (context) => {
    // questionObjectに変換
    const sheet = context.workbook.worksheets.getItem(sheetName);
    const values = await getJson(context, sheet, rangeText.replace("C", "B"));

    let prevJson = [];
    let questionJson = values;

    if (pageBreaks.includes(values[0]["questionType"])) {
      questionJson = values.filter((_, i) => i >= 1);
      prevJson = values.filter((_, i) => i < 1);
    }

    const questionObjTmp = getQuestionObj(questionId, questionJson, prevJson);

    const deleteRange = sheet.getRange(rangeText);
    deleteRange.getEntireRow().delete(Excel.DeleteShiftDirection.up);

    return questionObjTmp;
  });

  const { rangeFrom } = await getQuestionRangeWithId(
    excel[newIndex],
    excel[newIndex + 1],
    sheetName
  );

  const questionRowsCount = getQuestionRowsCount(questionObj);
  let rangeTextInsert = `C${rangeFrom}:N${rangeFrom + questionRowsCount - 1}`;

  await Excel.run(async (context) => {
    // 行追加して...
    const sheet = context.workbook.worksheets.getItem(sheetName);
    sheet.getRange(rangeTextInsert).getEntireRow().insert(Excel.InsertShiftDirection.down);
    await context.sync();

    // 値を貼り付け
    await pasteQuestionValue(context, sheet, questionObj, rangeFrom);

    // ページ改定の確認＆挿入
    if (questionObj.forwardPageBreak) {
      await insertPageBreak(context, sheet, rangeFrom - 1, "forward");
    }
  });
}
